// extracted by mini-css-extract-plugin
export default {"marcWrapper":"marcWrapper---Y3jLN","marc":"marc---GVV6X"};